/**
 * Sidebar card shown when the workspace Boost balance is low or depleted.
 * Lives in the sidebar footer so it never pushes the page content down;
 * in the collapsed sidebar it shrinks to the Buy Boosts icon.
 */

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Zap } from "lucide-react";
import { usePayment } from "../lib/PaymentContext";
import { publicRoutes } from "../lib/routes";

const BOOST_LOW_THRESHOLD = 100;

export default function InsufficientBoostsBanner() {
  const { t } = useTranslation();
  const { boostBalance, loading, billingHidden } = usePayment();

  if (loading || billingHidden || boostBalance >= BOOST_LOW_THRESHOLD) return null;

  const isZero = boostBalance <= 0;
  const message = isZero
    ? t("billing.boostAlert.empty")
    : t("billing.boostAlert.low", { count: boostBalance });

  return (
    <div
      role="status"
      className="mb-3 rounded-xl border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/50 p-3"
    >
      <p className="footer-text text-xs text-amber-800 dark:text-amber-200 mb-2">{message}</p>
      <Link
        to={publicRoutes.billing}
        title={message}
        className="nav-item inline-flex items-center gap-1.5 rounded-lg bg-amber-600 px-2.5 py-1.5 text-xs font-medium text-white hover:bg-amber-700 transition-colors"
      >
        <Zap className="h-3.5 w-3.5 shrink-0" />
        <span className="footer-text">{t("billing.boostAlert.buy")}</span>
      </Link>
    </div>
  );
}
